/**
 * SETTINGS ARCHITECTURE — SINGLE SOURCE OF TRUTH
 *
 * ⚠️  STRICT RULES FOR ALL FUTURE AGENTS:
 *   1. NEVER remove a section from SETTINGS_SECTIONS.
 *   2. NEVER rewrite Settings.js from scratch — only extend.
 *   3. To add a new section: push a new entry here AND add the corresponding
 *      JSX block in Settings.js with data-settings-section="<key>".
 *   4. Each entry maps directly to a <Card data-settings-section="key"> in Settings.js.
 *
 * Rule: EXTEND, NEVER REPLACE.
 */

export const SETTINGS_SECTIONS = [
  {
    key: 'billing',
    label: 'Billing Overview',
    roles: ['owner', 'manager', 'supervisor', 'staff'],
    required: true,
    description: 'Subscription plan, status, and billing cycle.',
  },
  {
    key: 'business',
    label: 'Business Settings',
    roles: ['owner', 'super_admin'],
    required: true,
    description: 'Reporting currency and display preferences.',
  },
  {
    key: 'overtime',
    label: 'Overtime & Holiday Pay',
    roles: ['owner', 'super_admin'],
    required: true,
    description: 'Overtime thresholds, break rules, holiday dates, and RPLH target.',
  },
  {
    key: 'ai',
    label: 'AI Configuration',
    roles: ['owner', 'super_admin'],
    required: true,
    description: 'Eva AI workforce assistant — provider and API key.',
  },
  {
    key: 'resend',
    label: 'Staff Email Notifications',
    roles: ['owner', 'admin', 'super_admin', 'manager', 'supervisor'],
    required: true,
    description: 'Resend REST API configuration for tenant transactional emails.',
  },
  {
    key: 'locations',
    label: 'Locations',
    roles: ['owner', 'manager', 'supervisor', 'staff'],
    required: true,
    description: 'Manage restaurant/outlet locations under the group.',
  },
  {
    key: 'upgrade',
    label: 'Upgrade Plan',
    roles: ['owner'],
    required: false,
    description: 'Shown only for single-plan tenants.',
  },
  {
    key: 'payment_admin',
    label: 'Payment Processor (Admin)',
    roles: ['super_admin'],
    required: false,
    description: 'Stripe & Xendit configuration — super admin only.',
  },
  {
    key: 'canadian_payroll',
    label: 'Canadian Payroll',
    roles: ['owner', 'manager', 'super_admin'],
    required: false,
    description: 'Employer legal name + address printed on Canadian payslips. Visible only for Canadian tenants.',
  },
  {
    key: 'mcp_connections',
    label: 'AI Connections',
    roles: ['owner', 'manager', 'super_admin'],
    required: false,
    description: 'Manage which AI assistants (ChatGPT, Claude, Gemini) can access this tenant via MCP. Disconnect revokes access immediately.',
  },
];

/** Keys that MUST always be present in the rendered Settings page. */
export const REQUIRED_SECTION_KEYS = SETTINGS_SECTIONS
  .filter((s) => s.required)
  .map((s) => s.key);
